/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.header-container[_ngcontent-%COMP%]{height:52px}.header-container[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100px;max-height:52px}.header-container[_ngcontent-%COMP%]   .date[_ngcontent-%COMP%]{font-size:1rem;color:#717d8d;margin-right:3px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-header/pdf-viewer-header.component.scss.shim.ngstyle.js.pre-build-optimizer.js